import React from "react";

import { passParamsThrough } from "../../../validation/HForm";
import { LayoutClientsReport } from "./LayoutClientsReport";
import { LayoutOperationReport } from "./LayoutOperationReport";
import { viewReports } from "../../../helpers/data-constants";

const customSelectStyles = {
  menuList: (provided) => ({
    ...provided,
    maxHeight: 150,
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    fontSize: "100%",
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#ECEFF6",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#1E388B",
    ":hover": {
      backgroundColor: "#A7BBFA",
    },
  }),
};

const reportComponents = {
    [viewReports.CLIENTS_REPORT]: LayoutClientsReport,
    [viewReports.OPERATIONS_REPORT]: LayoutOperationReport,
};

export const ReportFilter = ({
    type,
    cashBoxesClient,
    resetError,
    ...props
}) => {
    const ReportComponent = reportComponents[type];

    return ReportComponent ? (
        passParamsThrough(
            <ReportComponent
                h="true"
                cashBoxesClient={cashBoxesClient}
                resetError={resetError}
                styles={customSelectStyles}
            />,
            props
        )
    ) : null;
};
